<div *ngIf="loading" class="loading-text">
  <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
</div>

<div *ngIf="!loading">
<app-sub-header [pageTitle]="'Clients' | translate"></app-sub-header>

<div class="padded-container" *ngIf="clientListResponse">
    <div *ngFor="let client of clientListResponse.clientList">
      <dx-button type="default" class="full-width-button" (click)="continueNextStep(client.id)">
        {{ client.description }}
      </dx-button>
    </div>
    <dx-button type="danger" class="full-width-button" (click)="navigateToRulesCheck()">
      {{ 'Back' | translate }}
    </dx-button>
  </div>
</div>